import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, createSlots as _createSlots, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e8646f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"display":"flex","justify-content":"center","align-items":"center","height":"35px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-plus" }, null, -1))
const _hoisted_3 = {
  class: "",
  style: {"display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-minus" }, null, -1))
const _hoisted_5 = {
  class: "",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_6 = {
  key: 0,
  class: "gap-x-4",
  style: {"display":"flex","align-items":"center","flex":"1"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont cm-icon-info",
  style: {"font-weight":"normal"}
}, null, -1))
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  class: "cm-ui-ml5",
  style: {"position":"relative","top":"-2px"}
}
const _hoisted_10 = {
  key: 0,
  class: "gap-x-4",
  style: {"display":"flex","align-items":"center","flex":"1"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-info" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "cm-label"
}
const _hoisted_13 = {
  class: "",
  style: {"box-sizing":"border-box"}
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont cm-icon-right" })
], -1))
const _hoisted_16 = {
  key: 0,
  style: {"line-height":"1rem","font-size":"14px","color":"var(--cm-color-text-regular)"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-plus" }, null, -1))

import { getFormItemRules, getLabel, getValue } from '@/hooks'
import { computed, PropType } from 'vue'
import { FormType, FormItem, GlobalOpt, TableOpt } from './types'
import { useCmFormDefaultPlaceholder } from './useCmFormDefaultPlaceholder'

export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicFormTable',
  props: {
  dynamicFormItem: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: Object,
    required: true,
  },
  tableOpt: {
    type: Object as PropType<TableOpt>,
    default: () => ({}),
  },
  globalOpt: {
    type: Object as PropType<GlobalOpt>,
    default: () => ({}),
  },
  prop: {
    type: String,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const { placeholderInput: phInput, placeholderSelect: phSelect } =
  useCmFormDefaultPlaceholder()
function placeholderInput(fi: object) {
  return phInput(fi as FormItem<any, any>)
}
function placeholderSelect(fi: object) {
  return phSelect(fi as FormItem<any, any>)
}
const form = computed({
  get: () => props.modelValue,
  set: (val: any) => emit('update:modelValue', val),
})
const getIndex = computed(
  () => (key: number | string, formItemIndex: number | undefined) =>
    (Array.isArray(props.dynamicFormItem?.columns) && formItemIndex) || key,
)
const getKey = computed(
  () => (key: number | string, formItem: { prop?: string }) =>
    (Array.isArray(props.dynamicFormItem?.columns) && formItem.prop) || key,
)
const maxDisabled = computed(
  () =>
    props.dynamicFormItem?.maxCount <=
    form.value?.[props?.dynamicFormItem?.prop]?.length,
)
const leastDisabled = computed(
  () => props.dynamicFormItem?.leastCount >= form.value[props.prop]?.length,
)
const handle = (type: string, index?: number, row?: any): void => {
  const types: any = {
    add: () =>
      props.dynamicFormItem.rowAdd((row: any) =>
        form.value?.[props.prop].push(row),
      ),
    remove: (index: number) => {
      props.dynamicFormItem.rowDel(row, () =>
        form.value?.[props.prop].splice(index, 1),
      )
    },
  }
  types?.[type]?.(index, row)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: "el-card dynamic_table-is-error",
    style: __props.tableOpt.bodyStyle ?? 'padding:7px 10px;'
  }, __props.tableOpt.cardOpt), [
    _createVNode(_component_el_table, _mergeProps({
      data: form.value[__props.prop]
    }, { stripe: false, ...__props.tableOpt }, {
      "empty-text": _ctx.$t('common.noData'),
      style: {"width":"100%","box-sizing":"border-box","overflow-x":"hidden"}
    }, _toHandlers(__props.tableOpt.events ?? {})), {
      default: _withCtx(() => [
        (__props.dynamicFormItem.notNormal)
          ? (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
              key: 0,
              type: "index",
              width: "70",
              index: 1
            }, _toHandlers(_ctx.dynamicformItem.events ?? {}), { align: "center" }), {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (__props.dynamicFormItem.notNormal)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (handle('add'))),
                        size: "small",
                        circle: "",
                        type: "primary",
                        disabled: maxDisabled.value,
                        class: _normalizeClass(__props.dynamicFormItem.notNormal && 'remove-btn')
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }, 8, ["disabled", "class"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(__props.dynamicFormItem.notNormal && 'no')
                  }, "编号", 2)
                ])
              ]),
              default: _withCtx(({ row, $index }) => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: _normalizeClass(__props.dynamicFormItem.notNormal && 'no')
                  }, _toDisplayString($index + 1), 3),
                  (__props.dynamicFormItem.notNormal)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        size: "small",
                        type: "danger",
                        circle: "",
                        onClick: ($event: any) => (handle('remove', $index, row)),
                        class: _normalizeClass(__props.dynamicFormItem.notNormal && 'remove-btn'),
                        disabled: leastDisabled.value
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class", "disabled"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dynamicFormItem.columns, (formItem, key, formIndex) => {
          return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: getIndex.value(key, formIndex),
            label: formItem.label,
            prop: getKey.value(key, formItem),
            width: formItem.width,
            fixed: formItem.fixed,
            align: formItem.align,
            ref_for: true
          }, formItem.tableColumnOpt), {
            header: _withCtx(() => [
              _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-header', {
                formItem: formItem,
                formItemIndex: getIndex.value(key, formIndex)
              }, () => [
                _createElementVNode("div", _hoisted_5, [
                  (!formItem.hiddenAllHeader)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (formItem.tip)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, _mergeProps({
                              key: 0,
                              effect: "dark",
                              ref_for: true
                            }, formItem.tipOpt, {
                              content: formItem.tip
                            }), {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 2
                            }, 1040, ["content"]))
                          : _createCommentVNode("", true),
                        (!formItem.hiddenHeader)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["cm-label", (__props.globalOpt?.required ?? formItem.required)
                  ? 'cm-is-required'
                  : ''
                  ])
                            }, [
                              _renderSlot(_ctx.$slots, __props.prop + '-dynamicTable-label', {
                                formItem: formItem,
                                label: formItem.label,
                                prop: __props.prop
                              }, () => [
                                _createTextVNode(_toDisplayString(formItem.label), 1)
                              ]),
                              (formItem.suffixTip)
                                ? (_openBlock(), _createBlock(_component_el_tooltip, _mergeProps({
                                    key: 0,
                                    effect: "light",
                                    ref_for: true
                                  }, formItem.suffixTipOpt), {
                                    content: _withCtx(() => [
                                      _createElementVNode("div", {
                                        style: {"width":"400px"},
                                        innerHTML: formItem.suffixTip
                                      }, null, 8, _hoisted_8)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("i", _hoisted_9, [
                                        _createVNode(_component_CmSvgIcon, {
                                          name: "assets/icons/info-gray",
                                          color: "var(--el-color-info)",
                                          size: 17
                                        })
                                      ])
                                    ]),
                                    _: 2
                                  }, 1040))
                                : _createCommentVNode("", true)
                            ], 2))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            default: _withCtx(({ row: item, $index: index }) => [
              _createVNode(_component_el_row, { class: "item-hover" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, _mergeProps({ ref_for: true }, { ...__props.globalOpt.colOpt, ...formItem.colOpt }), {
                    default: _withCtx(() => [
                      (!formItem.hidden)
                        ? (_openBlock(), _createBlock(_component_el_form_item, _mergeProps({
                            key: 0,
                            prop: `${__props.prop}.${index}.${getKey.value(key, formItem)}`,
                            rules: _unref(getFormItemRules)(__props.globalOpt.required, formItem),
                            ref_for: true
                          }, formItem.formItemOpt), _createSlots({
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, [
                                _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-slot', {
                                  prop: getKey.value(key, formItem),
                                  formItem: formItem,
                                  index: index,
                                  formItemIndex: getIndex.value(key, formIndex)
                                }, () => [
                                  (formItem.type === _unref(FormType).Text)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item[getKey.value(key, formItem)]), 1))
                                    : _createCommentVNode("", true),
                                  (!formItem.type)
                                    ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                                        key: 1,
                                        modelModifiers: formItem.modelModifiers
                                      }, _toHandlers(formItem.events ?? {}), {
                                        type: formItem.inputType,
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        disabled: formItem.disabled?.(),
                                        placeholder: placeholderInput(formItem),
                                        ref_for: true
                                      }, formItem.inputOpt), _createSlots({ _: 2 }, [
                                        (formItem.prependSlot)
                                          ? {
                                              name: "prepend",
                                              fn: _withCtx(() => [
                                                _renderSlot(_ctx.$slots, "prepend")
                                              ]),
                                              key: "0"
                                            }
                                          : undefined,
                                        (formItem.appendSlot)
                                          ? {
                                              name: "append",
                                              fn: _withCtx(() => [
                                                _renderSlot(_ctx.$slots, "append")
                                              ]),
                                              key: "1"
                                            }
                                          : undefined
                                      ]), 1040, ["modelModifiers", "type", "modelValue", "onUpdate:modelValue", "disabled", "placeholder"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).InputNumber)
                                    ? (_openBlock(), _createBlock(_component_el_input_number, _mergeProps({
                                        key: 2,
                                        modelModifiers: formItem.modelModifiers
                                      }, _toHandlers(formItem.events ?? {}), {
                                        placeholder: placeholderInput(formItem),
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        disabled: formItem.disabled?.(),
                                        ref_for: true
                                      }, formItem.inputNumOpt), null, 16, ["modelModifiers", "placeholder", "modelValue", "onUpdate:modelValue", "disabled"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).Cascader)
                                    ? (_openBlock(), _createBlock(_component_el_cascader, _mergeProps({
                                        key: 3,
                                        modelModifiers: formItem.modelModifiers,
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        options: formItem.dictData,
                                        placeholder: placeholderSelect(formItem),
                                        disabled: formItem.disabled?.(),
                                        props: formItem.props
                                      }, _toHandlers((typeof formItem.events === 'function' ? formItem.events(index) : formItem.events) ?? {}), { ref_for: true }, formItem.cascaderOpt), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "options", "placeholder", "disabled", "props"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).Select)
                                    ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                                        key: 4,
                                        modelModifiers: formItem.modelModifiers,
                                        ref_for: true
                                      }, formItem.selectOpt, _toHandlers(formItem.events ?? {}), {
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        disabled: formItem.disabled?.(),
                                        placeholder: placeholderSelect(formItem)
                                      }), {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.dictData ?? formItem.dictData, (opt) => {
                                            return (_openBlock(), _createBlock(_component_el_option, _mergeProps({
                                              modelModifiers: formItem.modelModifiers
                                            }, _toHandlers(opt.events ?? {}), { ref_for: true }, opt.opt, {
                                              key: opt[_unref(getValue)(formItem.props)],
                                              disabled: opt.disabled,
                                              label: opt[_unref(getLabel)(formItem.props)],
                                              value: opt[_unref(getValue)(formItem.props)]
                                            }), null, 16, ["modelModifiers", "disabled", "label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1040, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled", "placeholder"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).SelectGroup)
                                    ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                                        key: 5,
                                        modelModifiers: formItem.modelModifiers,
                                        ref_for: true
                                      }, formItem.selectGroupOpt, { style: {"width":"100%"} }, _toHandlers(formItem.events ?? {}), {
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        disabled: formItem.disabled?.(),
                                        placeholder: placeholderSelect(formItem)
                                      }), {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.dictData, (group) => {
                                            return (_openBlock(), _createBlock(_component_el_option_group, {
                                              key: group.label,
                                              label: group.label
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.dictData ?? group.dictData, (opt) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, _mergeProps({
                                                    modelModifiers: formItem.modelModifiers
                                                  }, _toHandlers(opt.events ?? {}), { ref_for: true }, opt.opt, {
                                                    key: opt[_unref(getValue)(group.props)],
                                                    disabled: opt.disabled,
                                                    label: opt[_unref(getLabel)(group.props)],
                                                    value: opt[_unref(getValue)(group.props)]
                                                  }), null, 16, ["modelModifiers", "disabled", "label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["label"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1040, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled", "placeholder"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).Rate)
                                    ? (_openBlock(), _createBlock(_component_el_rate, _mergeProps({
                                        key: 6,
                                        modelModifiers: formItem.modelModifiers
                                      }, _toHandlers(formItem.events ?? {}), {
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        ref_for: true
                                      }, formItem.rateOpt, {
                                        disabled: formItem.disabled?.()
                                      }), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).Date)
                                    ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                                        key: 7,
                                        modelModifiers: formItem.modelModifiers
                                      }, _toHandlers(formItem.events ?? {}), {
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        type: formItem.dateType || _unref(FormType).Date,
                                        "aria-label": `Pick a ${formItem.dateType || _unref(FormType).Date}`,
                                        placeholder: placeholderSelect(formItem),
                                        style: {"width":"100%"},
                                        ref_for: true
                                      }, formItem.dateOpt), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "type", "aria-label", "placeholder"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).Segmented)
                                    ? (_openBlock(), _createBlock(_component_el_segmented, _mergeProps({
                                        key: 8,
                                        modelModifiers: formItem.modelModifiers
                                      }, _toHandlers(formItem.events ?? {}), {
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        disabled: formItem.disabled?.(),
                                        options: formItem.options
                                      }), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled", "options"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).Time)
                                    ? (_openBlock(), _createBlock(_component_el_time_picker, _mergeProps({
                                        key: 9,
                                        modelModifiers: formItem.modelModifiers
                                      }, _toHandlers(formItem.events ?? {}), {
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        "aria-label": formItem.label,
                                        disabled: formItem.disabled?.(),
                                        placeholder: placeholderSelect(formItem),
                                        style: {"width":"100%"},
                                        ref_for: true
                                      }, formItem.timeOpt), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "aria-label", "disabled", "placeholder"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).Switch)
                                    ? (_openBlock(), _createBlock(_component_el_switch, _mergeProps({
                                        key: 10,
                                        modelModifiers: formItem.modelModifiers
                                      }, _toHandlers(formItem.events ?? {}), {
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        ref_for: true
                                      }, formItem.switchOpt, {
                                        disabled: formItem.disabled?.()
                                      }), null, 16, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).CheckboxGroup)
                                    ? (_openBlock(), _createBlock(_component_el_checkbox_group, _mergeProps({
                                        key: 11,
                                        modelModifiers: formItem.modelModifiers
                                      }, _toHandlers(formItem.events ?? {}), {
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        disabled: formItem.disabled?.(),
                                        ref_for: true
                                      }, formItem.checkboxGroupOpt), {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.dictData ?? formItem.dictData, (opt) => {
                                            return (_openBlock(), _createBlock(_component_el_checkbox, _mergeProps({
                                              modelModifiers: formItem.modelModifiers
                                            }, _toHandlers(opt.events ?? {}), {
                                              key: opt[_unref(getValue)(formItem.props)],
                                              disabled: opt.disabled,
                                              ref_for: true
                                            }, formItem.checkboxOpt, {
                                              value: opt[_unref(getValue)(formItem.props)],
                                              label: opt[_unref(getValue)(formItem.props)]
                                            }), {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(opt[_unref(getLabel)(formItem.props)]), 1)
                                              ]),
                                              _: 2
                                            }, 1040, ["modelModifiers", "disabled", "value", "label"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1040, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).CheckboxGroupCm)
                                    ? (_openBlock(), _createBlock(_component_el_checkbox_group, _mergeProps({
                                        key: 12,
                                        class: "cm-checkbox-group gap-10",
                                        modelModifiers: formItem.modelModifiers
                                      }, _toHandlers(formItem.events ?? {}), {
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        disabled: formItem.disabled?.(),
                                        ref_for: true
                                      }, formItem.checkboxGroupOpt), {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.dictData ?? formItem.dictData, (opt) => {
                                            return (_openBlock(), _createBlock(_component_el_checkbox, _mergeProps({
                                              modelModifiers: formItem.modelModifiers,
                                              class: "cm-checkbox el-card"
                                            }, _toHandlers(opt.events ?? {}), {
                                              key: opt[_unref(getValue)(formItem.props)],
                                              disabled: opt.disabled,
                                              ref_for: true
                                            }, formItem.checkboxOpt, {
                                              value: opt[_unref(getValue)(formItem.props)],
                                              label: opt[_unref(getValue)(formItem.props)]
                                            }), {
                                              default: _withCtx(() => [
                                                _createElementVNode("img", _mergeProps({ ref_for: true }, opt.svgOpt, {
                                                  alt: "",
                                                  class: "cm-svg cm-ui-mr10"
                                                }), null, 16),
                                                _createTextVNode(" " + _toDisplayString(opt[_unref(getLabel)(formItem.props)]) + " ", 1),
                                                _hoisted_15
                                              ]),
                                              _: 2
                                            }, 1040, ["modelModifiers", "disabled", "value", "label"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1040, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled"]))
                                    : _createCommentVNode("", true),
                                  (formItem.type === _unref(FormType).Radio)
                                    ? (_openBlock(), _createBlock(_component_el_radio_group, _mergeProps({
                                        key: 13,
                                        modelModifiers: formItem.modelModifiers
                                      }, _toHandlers(formItem.events ?? {}), {
                                        modelValue: item[getKey.value(key, formItem)],
                                        "onUpdate:modelValue": ($event: any) => ((item[getKey.value(key, formItem)]) = $event),
                                        disabled: formItem.disabled?.()
                                      }), {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.dictData ?? formItem.dictData, (opt) => {
                                            return (_openBlock(), _createBlock(_component_el_radio, _mergeProps({
                                              modelModifiers: formItem.modelModifiers
                                            }, _toHandlers(opt.events ?? {}), {
                                              key: opt[_unref(getValue)(formItem.props)],
                                              disabled: opt.disabled,
                                              label: opt[_unref(getValue)(formItem.props)],
                                              value: opt[_unref(getValue)(formItem.props)]
                                            }), {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(opt[_unref(getLabel)(formItem.props)]), 1)
                                              ]),
                                              _: 2
                                            }, 1040, ["modelModifiers", "disabled", "label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1040, ["modelModifiers", "modelValue", "onUpdate:modelValue", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                (formItem.tip)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(formItem.tip), 1))
                                  : _createCommentVNode("", true),
                                _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-dynamicTable-footer')
                              ])
                            ]),
                            _: 2
                          }, [
                            (!formItem.hiddenAllLabel)
                              ? {
                                  name: "label",
                                  fn: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-dynamicTable-label', { formItem: formItem }, () => [
                                      (!formItem.hiddenAllLabel)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            (formItem.tip)
                                              ? (_openBlock(), _createBlock(_component_el_tooltip, _mergeProps({
                                                  key: 0,
                                                  effect: "dark",
                                                  ref_for: true
                                                }, formItem.tipOpt, {
                                                  content: formItem.tip
                                                }), {
                                                  default: _withCtx(() => [
                                                    _hoisted_11
                                                  ]),
                                                  _: 2
                                                }, 1040, ["content"]))
                                              : _createCommentVNode("", true),
                                            (!formItem.hiddenLabel)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(formItem.label), 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  key: "0"
                                }
                              : undefined
                          ]), 1040, ["prop", "rules"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1040, ["label", "prop", "width", "fixed", "align"]))
        }), 128)),
        (!__props.dynamicFormItem.notNormal && !__props.dynamicFormItem.hiddenDelBtn)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: _ctx.$t('listColumns.operation'),
              width: "70"
            }, {
              default: _withCtx(({ row, $index }) => [
                _createVNode(_component_el_link, _mergeProps({
                  disabled: leastDisabled.value || __props.dynamicFormItem.disabledDel?.(),
                  onClick: _withModifiers(($event: any) => (handle('remove', $index, row)), ["prevent"])
                }, __props.dynamicFormItem.removeOpt), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.dynamicFormItem.removeText), 1)
                  ]),
                  _: 2
                }, 1040, ["disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 16, ["data", "empty-text"]),
    (!__props.dynamicFormItem.notNormal && !__props.dynamicFormItem.hiddenPlusBtn)
      ? (_openBlock(), _createBlock(_component_el_button, _mergeProps({
          key: 0,
          disabled: maxDisabled.value || __props.dynamicFormItem.disabledPlus?.()
        }, __props.dynamicFormItem.plusOpt, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handle('add')))
        }), {
          default: _withCtx(() => [
            _hoisted_17,
            _createTextVNode(" " + _toDisplayString(__props.dynamicFormItem.plusText), 1)
          ]),
          _: 1
        }, 16, ["disabled"]))
      : _createCommentVNode("", true)
  ], 16))
}
}

})